// Generated by purs version 0.11.7
"use strict";
var $foreign = require("./foreign");
module.exports = {
    unsafeCoerce: $foreign.unsafeCoerce
};



//////////////////
// WEBPACK FOOTER
// ./output/Unsafe.Coerce/index.js
// module id = 56
// module chunks = 0